import type { AccessCapabilities, AccessPreview } from '@/types/access';
import type { AuthSessionPayload } from '@/contexts/authStateContext';

export const ACCESS_POLICY_CHANGED_EVENT = 'access:policy_changed';

export type AccessMeBody = {
  capabilities: AccessCapabilities;
  preview: AccessPreview | null;
  group_slug: string | null;
  access: string | null;
};

export function applyAccessMeToSession(
  current: AuthSessionPayload,
  me: AccessMeBody
): AuthSessionPayload {
  return {
    user: { ...current.user, access: me.access },
    sessionExpiresAt: current.sessionExpiresAt,
    capabilities: me.capabilities,
    preview: me.preview,
    group_slug: me.group_slug,
  };
}

let refreshInFlight: Promise<void> | null = null;

export async function refreshAccessPolicyOnClient(opts: {
  fetchMe: () => Promise<AccessMeBody>;
  getSession: () => AuthSessionPayload | null;
  setSession: (session: AuthSessionPayload) => void;
  clearQueries: () => void;
}): Promise<void> {
  if (refreshInFlight) return refreshInFlight;
  refreshInFlight = (async () => {
    const current = opts.getSession();
    if (!current) return;
    const me = await opts.fetchMe();
    opts.setSession(applyAccessMeToSession(current, me));
    opts.clearQueries();
  })().finally(() => {
    refreshInFlight = null;
  });
  return refreshInFlight;
}
